// Explicit separators allow alternatives while keeping multiword names/addresses intact.
export function directorySearchTerms(query = '') {
    return [...new Set(String(query).toLocaleLowerCase()
        .split(/[,;\n]+|\s+(?:and|or)\s+/i)
        .map(term => term.trim()).filter(Boolean))];
}

export function matchesDirectorySearch(values, terms) {
    if (!terms.length) return true;
    const fields = values.map(value => String(value ?? '').toLocaleLowerCase());
    return terms.some(term => fields.some(field => field.includes(term)));
}
